import styled, { css } from 'styled-components';

import { mediaQueries } from 'styles/helpers';

export const IframeContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;

  iframe {
    border: none;
    width: 100vw;
    min-height: 100%;
    padding: 0px 10px;
  }
  ${mediaQueries(
    'lg',
    css`
      padding: 50px 0px;
    `
  )}
`;
